import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

const BulkImportStep2 = ({
  data,
  serverErrorList,
  localErrorList,
  setServerErrors,
  prevStep,
  nextStep,
}) => {
  const { t: translator } = useTranslation();
  const [parsedErrors, setParsedErrors] = useState();
  const [invalidRows, setInvalidRows] = useState();
  const maxNumberOfErrors = 3000;

  useEffect(() => {
    if (localErrorList) {
      setInvalidRows([]);
      setParsedErrors(localErrorList);
    }

    return () => {
      setInvalidRows([]);
      setServerErrors();
    };
  }, [localErrorList]);

  useEffect(() => {
    setInvalidRows([]);
    if (serverErrorList) {
      let _errors = [];
      let _invalidRows = [];
      if (Array.isArray(serverErrorList)) {
        serverErrorList.forEach((x) => {
          let rowIndexS = x.name.match(/\[(.*?)\]/);
          let rowIndex = Number(rowIndexS?.[1] || 0) + 1;
          _invalidRows.push(rowIndex);
          _errors.push({
            index: rowIndex,
            errors: [x.value],
          });
        });
        setParsedErrors(_errors);
        setInvalidRows(_invalidRows);
      } else {
        let keys = Object.keys(serverErrorList);
        keys.forEach((x) => {
          let rowIndex = Number(x) + 1;
          _invalidRows.push(rowIndex);
          _errors.push({
            index: rowIndex,
            errors: serverErrorList[x],
          });
        });
        setParsedErrors(_errors);
        setInvalidRows(_invalidRows);
      }
    }
  }, [serverErrorList]);

  const [pagination, setPagination] = useState({
    totalCount: 0,
    pageSize: 10,
    pageIndex: 0,
  });

  const columns = data.meta.fields.map((x) => ({
    dataField: x,
    text: x,
  }));

  const rowClasses = (row, rowIndex) => {
    let classes = null;

    if (invalidRows && invalidRows.includes(rowIndex + 1)) {
      classes = "invalid-record";
    }

    return classes;
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          {parsedErrors && (
            <div className="invalid-record mb-3 p-3">
              {parsedErrors && parsedErrors.length > maxNumberOfErrors && (
                <>
                  {translator("BulkimportStep2-ImportedFIle")}{" "}
                  {parsedErrors.length}{" "}
                  {translator("BulkimportStep2-InvalidRecord")}
                </>
              )}
              {parsedErrors && parsedErrors.length <= maxNumberOfErrors && (
                <>
                  <table>
                    {parsedErrors.map((x) => {
                      return x.errors.map((e, i) => {
                        if (i === 0) {
                          return (
                            <tr>
                              <td>
                                {translator("BulkimportStep2-Row")} {x.index}:
                              </td>
                              <td>{translator(e)}</td>
                            </tr>
                          );
                        } else {
                          return (
                            <tr>
                              <td></td>
                              <td>{translator(e)}</td>
                            </tr>
                          );
                        }
                      });
                    })}
                  </table>
                </>
              )}
            </div>
          )}
          {data && (
            <>
              <p>
                {translator("BulkimportStep2-Loaded")} {data.data.length}{" "}
                {translator("BulkimportStep2-Records")}
              </p>
              <BootstrapTable
                keyField="Code"
                data={data.data}
                columns={columns}
                pagination={paginationFactory({
                  page: pagination.pageIndex + 1,
                  sizePerPage: pagination.pageSize,
                  totalSize: pagination.totalCount,
                })}
                rowClasses={rowClasses}
              />
            </>
          )}
        </div>
      </div>
      <div className="row mt-3">
        <div className="col-6">
          <button className="btn btn-outline-secondary" onClick={prevStep}>
            {translator("Onboarding-Btn-Back")}
          </button>
        </div>
        <div className="col-6 text-right">
          <button
            className="btn btn-primary"
            onClick={nextStep}
            disabled={parsedErrors}
          >
            {translator("Onboarding-Btn-Next")}
          </button>
        </div>
      </div>
    </>
  );
};

export default BulkImportStep2;
